export default "__VITE_ASSET__946788b0__"